module.exports = __webpack_public_path__ + "static/media/poppins-v5-latin-ext-regular.25700972.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/poppins-v5-latin-ext-regular.woff
// module id = ./src/common/fonts/poppins-v5-latin-ext-regular.woff
// module chunks = 1